import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';
import RevertExchangeButton from './RevertExchangeButton';

export default withUser(withRouter(RevertExchangeButton));
